// import React, { useEffect, useMemo, useState } from "react";
// import { useAuth } from "../App";
// import Layout from "../components/Layout";
// import { Card, CardContent } from "../components/ui/card";
// import { Button } from "../components/ui/button";
// import { Badge } from "../components/ui/badge";
// import {
//   Select,
//   SelectContent,
//   SelectItem,
//   SelectTrigger,
//   SelectValue,
// } from "../components/ui/select";
// import { toast } from "sonner";
// import { Euro, QrCode, CheckCircle2, History, RefreshCw, X } from "lucide-react";
// import QRCode from "qrcode";

// const MONTHS = [
//   { value: "01", label: "Janvier" },
//   { value: "02", label: "Février" },
//   { value: "03", label: "Mars" },
//   { value: "04", label: "Avril" },
//   { value: "05", label: "Mai" },
//   { value: "06", label: "Juin" },
//   { value: "07", label: "Juillet" },
//   { value: "08", label: "Août" },
//   { value: "09", label: "Septembre" },
//   { value: "10", label: "Octobre" },
//   { value: "11", label: "Novembre" },
//   { value: "12", label: "Décembre" },
// ];

// function buildEpcPayload({ bic, beneficiary, iban, amount, communication }) {
//   // EPC QR Code (SEPA Credit Transfer)
//   // BIC peut être vide dans beaucoup de cas SEPA.
//   return [
//     "BCD",
//     "002",
//     "1",
//     "SCT",
//     (bic || "").trim(),
//     (beneficiary || "").trim().slice(0, 70),
//     (iban || "").replace(/\s+/g, "").toUpperCase(),
//     `EUR${Number(amount || 0).toFixed(2)}`,
//     "",
//     (communication || "").trim().slice(0, 140),
//     "",
//   ].join("\n");
// }

// export default function Payments() {
//   const { axiosInstance } = useAuth();

//   const now = new Date();
//   const [month, setMonth] = useState(
//     String(now.getMonth() + 1).padStart(2, "0")
//   );
//   const [year, setYear] = useState(String(now.getFullYear()));
//   const [loading, setLoading] = useState(false);
//   const [workers, setWorkers] = useState([]);
//   const [summary, setSummary] = useState({
//     workers: 0,
//     total: 0,
//     paid: 0,
//     pending: 0,
//   });
//   const [history, setHistory] = useState([]);
//   const [tab, setTab] = useState("current");

//   const [paymentModal, setPaymentModal] = useState({
//     open: false,
//     worker: null,
//     qrDataUrl: "",
//   });

//   const years = useMemo(() => {
//     const y = now.getFullYear();
//     return Array.from({ length: 7 }, (_, i) => String(y - 4 + i));
//   }, []);

//   const loadMonthlyPayments = async () => {
//     setLoading(true);
//     try {
//       const response = await axiosInstance.get(
//         `/admin/payroll/monthly?month=${Number(month)}&year=${Number(year)}`
//       );

//       setWorkers(response.data?.workers || []);
//       setSummary(
//         response.data?.summary || {
//           workers: 0,
//           total: 0,
//           paid: 0,
//           pending: 0,
//         }
//       );
//     } catch (error) {
//       toast.error(
//         error.response?.data?.detail ||
//           "Impossible de charger les paiements du mois"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const loadHistory = async () => {
//     try {
//       const response = await axiosInstance.get("/admin/payments/history");
//       setHistory(response.data || []);
//     } catch (error) {
//       toast.error("Impossible de charger l'historique des paiements");
//     }
//   };

//   useEffect(() => {
//     loadMonthlyPayments();
//   }, [month, year]);

//   useEffect(() => {
//     if (tab === "history") loadHistory();
//   }, [tab]);

//   const openPayment = async (worker) => {
//     if (!worker.iban) {
//       toast.error(
//         "Aucun IBAN enregistré pour ce soignant. Ajoute son IBAN dans son profil."
//       );
//       return;
//     }

//     const communication =
//       worker.payment_reference ||
//       `SANA-CARE ${worker.first_name} ${worker.last_name} ${month}/${year}`;

//     const payload = buildEpcPayload({
//       bic: worker.bic,
//       beneficiary:
//         worker.account_holder ||
//         `${worker.first_name || ""} ${worker.last_name || ""}`.trim(),
//       iban: worker.iban,
//       amount: worker.net,
//       communication,
//     });

//     try {
//       const qrDataUrl = await QRCode.toDataURL(payload, {
//         width: 320,
//         margin: 2,
//       });

//       setPaymentModal({
//         open: true,
//         worker,
//         qrDataUrl,
//       });
//     } catch {
//       toast.error("Erreur lors de la génération du QR code");
//     }
//   };

//   const confirmPayment = async () => {
//     const worker = paymentModal.worker;
//     if (!worker) return;

//     const ok = window.confirm(
//       `Confirmer le paiement de ${Number(worker.net || 0).toFixed(2)} € à ` +
//         `${worker.first_name} ${worker.last_name} pour ${month}/${year} ?`
//     );

//     if (!ok) return;

//     try {
//       await axiosInstance.post("/admin/payments/confirm", {
//         user_id: worker.user_id,
//         month: Number(month),
//         year: Number(year),
//       });

//       toast.success("Paiement enregistré dans l'historique");
//       setPaymentModal({ open: false, worker: null, qrDataUrl: "" });
//       await loadMonthlyPayments();
//     } catch (error) {
//       toast.error(
//         error.response?.data?.detail || "Erreur lors de la confirmation"
//       );
//     }
//   };

//   const statusBadge = (status) => {
//     if (status === "paid") {
//       return (
//         <Badge className="bg-emerald-100 text-emerald-700">
//           Payé
//         </Badge>
//       );
//     }

//     return (
//       <Badge className="bg-orange-100 text-orange-700">
//         À payer
//       </Badge>
//     );
//   };

//   return (
//     <Layout title="Paiements">
//       <div className="space-y-6">
//         <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
//           <div>
//             <h1 className="text-3xl font-bold text-gray-900">
//               Paiements des soignants
//             </h1>
//             <p className="text-gray-500 mt-1">
//               Sélectionne un mois pour voir uniquement les personnes ayant travaillé
//               pendant cette période.
//             </p>
//           </div>

//           <div className="flex gap-3 flex-wrap">
//             <div>
//               <label className="text-sm text-gray-600">Mois</label>
//               <Select value={month} onValueChange={setMonth}>
//                 <SelectTrigger className="w-[170px] bg-white">
//                   <SelectValue />
//                 </SelectTrigger>
//                 <SelectContent>
//                   {MONTHS.map((m) => (
//                     <SelectItem key={m.value} value={m.value}>
//                       {m.label}
//                     </SelectItem>
//                   ))}
//                 </SelectContent>
//               </Select>
//             </div>

//             <div>
//               <label className="text-sm text-gray-600">Année</label>
//               <Select value={year} onValueChange={setYear}>
//                 <SelectTrigger className="w-[120px] bg-white">
//                   <SelectValue />
//                 </SelectTrigger>
//                 <SelectContent>
//                   {years.map((y) => (
//                     <SelectItem key={y} value={y}>
//                       {y}
//                     </SelectItem>
//                   ))}
//                 </SelectContent>
//               </Select>
//             </div>

//             <Button
//               variant="outline"
//               onClick={loadMonthlyPayments}
//               disabled={loading}
//               className="self-end"
//             >
//               <RefreshCw size={16} className="mr-2" />
//               Actualiser
//             </Button>
//           </div>
//         </div>

//         <div className="flex gap-2">
//           <Button
//             onClick={() => setTab("current")}
//             variant={tab === "current" ? "default" : "outline"}
//             className={tab === "current" ? "bg-amber-600 hover:bg-amber-700" : ""}
//           >
//             <Euro size={16} className="mr-2" />
//             Paiements du mois
//           </Button>

//           <Button
//             onClick={() => setTab("history")}
//             variant={tab === "history" ? "default" : "outline"}
//             className={tab === "history" ? "bg-amber-600 hover:bg-amber-700" : ""}
//           >
//             <History size={16} className="mr-2" />
//             Historique
//           </Button>
//         </div>

//         {tab === "current" && (
//           <>
//             <div className="grid grid-cols-2 xl:grid-cols-4 gap-4">
//               <StatCard label="Soignants" value={summary.workers} />
//               <StatCard
//                 label="Montant total"
//                 value={`${Number(summary.total || 0).toFixed(2)} €`}
//               />
//               <StatCard label="Déjà payés" value={summary.paid} />
//               <StatCard label="Restant à payer" value={summary.pending} />
//             </div>

//             <Card>
//               <CardContent className="p-0 overflow-x-auto">
//                 <table className="w-full min-w-[900px]">
//                   <thead className="bg-amber-50">
//                     <tr>
//                       <th className="p-4 text-left">Soignant</th>
//                       <th className="p-4 text-left">Fonction</th>
//                       <th className="p-4 text-center">Prestations</th>
//                       <th className="p-4 text-right">Brut</th>
//                       <th className="p-4 text-right">Retenue</th>
//                       <th className="p-4 text-right">Net à payer</th>
//                       <th className="p-4 text-center">Statut</th>
//                       <th className="p-4 text-right">Action</th>
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {loading ? (
//                       <tr>
//                         <td colSpan={8} className="p-10 text-center text-gray-500">
//                           Chargement...
//                         </td>
//                       </tr>
//                     ) : workers.length === 0 ? (
//                       <tr>
//                         <td colSpan={8} className="p-10 text-center text-gray-500">
//                           Aucun soignant n'a de prestation terminée pour cette période.
//                         </td>
//                       </tr>
//                     ) : (
//                       workers.map((worker) => (
//                         <tr key={worker.user_id} className="border-t hover:bg-gray-50">
//                           <td className="p-4 font-semibold">
//                             {worker.first_name} {worker.last_name}
//                           </td>
//                           <td className="p-4">
//                             {worker.role === "nurse"
//                               ? "Infirmier"
//                               : worker.role === "caregiver"
//                               ? "Aide-soignant"
//                               : worker.role}
//                           </td>
//                           <td className="p-4 text-center">
//                             {worker.prestations_count}
//                           </td>
//                           <td className="p-4 text-right">
//                             {Number(worker.gross || 0).toFixed(2)} €
//                           </td>
//                           <td className="p-4 text-right text-red-600">
//                             -{Number(worker.discount || 0).toFixed(2)} €
//                           </td>
//                           <td className="p-4 text-right text-xl font-bold text-amber-700">
//                             {Number(worker.net || 0).toFixed(2)} €
//                           </td>
//                           <td className="p-4 text-center">
//                             {statusBadge(worker.payment_status)}
//                           </td>
//                           <td className="p-4 text-right">
//                             {worker.payment_status === "paid" ? (
//                               <Button variant="outline" disabled>
//                                 <CheckCircle2 size={16} className="mr-2" />
//                                 Déjà payé
//                               </Button>
//                             ) : (
//                               <Button
//                                 onClick={() => openPayment(worker)}
//                                 className="bg-emerald-600 hover:bg-emerald-700 text-white"
//                               >
//                                 <QrCode size={16} className="mr-2" />
//                                 Payer
//                               </Button>
//                             )}
//                           </td>
//                         </tr>
//                       ))
//                     )}
//                   </tbody>
//                 </table>
//               </CardContent>
//             </Card>
//           </>
//         )}

//         {tab === "history" && (
//           <Card>
//             <CardContent className="p-0 overflow-x-auto">
//               <table className="w-full min-w-[900px]">
//                 <thead className="bg-gray-50">
//                   <tr>
//                     <th className="p-4 text-left">Date</th>
//                     <th className="p-4 text-left">Soignant</th>
//                     <th className="p-4 text-left">Période</th>
//                     <th className="p-4 text-right">Montant</th>
//                     <th className="p-4 text-left">Référence</th>
//                     <th className="p-4 text-left">Confirmé par</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {history.length === 0 ? (
//                     <tr>
//                       <td colSpan={6} className="p-10 text-center text-gray-500">
//                         Aucun paiement enregistré
//                       </td>
//                     </tr>
//                   ) : (
//                     history.map((p) => (
//                       <tr key={p.id} className="border-t">
//                         <td className="p-4">
//                           {p.paid_at
//                             ? new Date(p.paid_at).toLocaleString("fr-BE")
//                             : "—"}
//                         </td>
//                         <td className="p-4 font-semibold">
//                           {p.first_name} {p.last_name}
//                         </td>
//                         <td className="p-4">
//                           {String(p.month).padStart(2, "0")}/{p.year}
//                         </td>
//                         <td className="p-4 text-right font-bold">
//                           {Number(p.net_amount || 0).toFixed(2)} €
//                         </td>
//                         <td className="p-4">{p.payment_reference || "—"}</td>
//                         <td className="p-4">{p.confirmed_by_name || "Admin"}</td>
//                       </tr>
//                     ))
//                   )}
//                 </tbody>
//               </table>
//             </CardContent>
//           </Card>
//         )}
//       </div>

//       {paymentModal.open && paymentModal.worker && (
//         <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4">
//           <div className="w-full max-w-xl bg-white rounded-2xl shadow-2xl overflow-hidden">
//             <div className="bg-amber-600 text-white p-5 flex justify-between items-center">
//               <div>
//                 <h2 className="text-2xl font-bold">Paiement</h2>
//                 <p>
//                   {paymentModal.worker.first_name}{" "}
//                   {paymentModal.worker.last_name}
//                 </p>
//               </div>

//               <Button
//                 size="sm"
//                 variant="ghost"
//                 className="text-white hover:bg-white/20"
//                 onClick={() =>
//                   setPaymentModal({ open: false, worker: null, qrDataUrl: "" })
//                 }
//               >
//                 <X />
//               </Button>
//             </div>

//             <div className="p-6 text-center">
//               <p className="text-gray-500">Montant à payer</p>
//               <p className="text-4xl font-bold text-amber-700 mt-1">
//                 {Number(paymentModal.worker.net || 0).toFixed(2)} €
//               </p>

//               <div className="mt-5 text-sm text-left bg-gray-50 rounded-xl p-4">
//                 <p>
//                   <b>IBAN :</b> {paymentModal.worker.iban}
//                 </p>
//                 <p>
//                   <b>Titulaire :</b>{" "}
//                   {paymentModal.worker.account_holder ||
//                     `${paymentModal.worker.first_name} ${paymentModal.worker.last_name}`}
//                 </p>
//                 <p>
//                   <b>Période :</b> {month}/{year}
//                 </p>
//                 <p>
//                   <b>Référence :</b>{" "}
//                   {paymentModal.worker.payment_reference ||
//                     `SANA-CARE ${paymentModal.worker.first_name} ${paymentModal.worker.last_name} ${month}/${year}`}
//                 </p>
//               </div>

//               <div className="flex justify-center mt-6">
//                 <img
//                   src={paymentModal.qrDataUrl}
//                   alt="QR code de paiement"
//                   className="w-[280px] h-[280px]"
//                 />
//               </div>

//               <p className="text-xs text-gray-500 mt-3">
//                 Scanne ce QR code avec une application bancaire compatible SEPA.
//               </p>

//               <Button
//                 onClick={confirmPayment}
//                 className="mt-6 w-full bg-emerald-600 hover:bg-emerald-700 text-white h-12"
//               >
//                 <CheckCircle2 size={18} className="mr-2" />
//                 Confirmer que le paiement est effectué
//               </Button>
//             </div>
//           </div>
//         </div>
//       )}
//     </Layout>
//   );
// }

// function StatCard({ label, value }) {
//   return (
//     <Card>
//       <CardContent className="p-5">
//         <p className="text-sm text-gray-500">{label}</p>
//         <p className="text-2xl font-bold mt-1">{value}</p>
//       </CardContent>
//     </Card>
//   );
// }



import React, { useEffect, useMemo, useState } from "react";
import { useAuth } from "../App";
import Layout from "../components/Layout";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../components/ui/select";
import { toast } from "sonner";
import {
  Euro,
  QrCode,
  CheckCircle2,
  History,
  RefreshCw,
  X,
} from "lucide-react";
import QRCode from "qrcode";

const SANA_BLUE = "#D4EBEB";
const SANA_BLUE_HOVER = "#BEDDDD";
const SANA_BLUE_TEXT = "#245B5B";

const MONTHS = [
  { value: "01", label: "Janvier" },
  { value: "02", label: "Février" },
  { value: "03", label: "Mars" },
  { value: "04", label: "Avril" },
  { value: "05", label: "Mai" },
  { value: "06", label: "Juin" },
  { value: "07", label: "Juillet" },
  { value: "08", label: "Août" },
  { value: "09", label: "Septembre" },
  { value: "10", label: "Octobre" },
  { value: "11", label: "Novembre" },
  { value: "12", label: "Décembre" },
];

function buildEpcPayload({
  bic,
  beneficiary,
  iban,
  amount,
  communication,
}) {
  return [
    "BCD",
    "002",
    "1",
    "SCT",
    (bic || "").trim(),
    (beneficiary || "").trim().slice(0, 70),
    (iban || "").replace(/\s+/g, "").toUpperCase(),
    `EUR${Number(amount || 0).toFixed(2)}`,
    "",
    (communication || "").trim().slice(0, 140),
    "",
  ].join("\n");
}

export default function Payments() {
  const { axiosInstance } = useAuth();

  const now = new Date();

  const [month, setMonth] = useState(
    String(now.getMonth() + 1).padStart(2, "0")
  );

  const [year, setYear] = useState(
    String(now.getFullYear())
  );

  const [loading, setLoading] = useState(false);

  const [workers, setWorkers] = useState([]);

  const [summary, setSummary] = useState({
    workers: 0,
    total: 0,
    paid: 0,
    pending: 0,
  });

  const [history, setHistory] = useState([]);

  const [tab, setTab] = useState("current");

  const [paymentModal, setPaymentModal] = useState({
    open: false,
    worker: null,
    qrDataUrl: "",
  });

  const years = useMemo(() => {
    const y = now.getFullYear();

    return Array.from(
      { length: 7 },
      (_, i) => String(y - 4 + i)
    );
  }, []);

  const loadMonthlyPayments = async () => {
    setLoading(true);

    try {
      const response = await axiosInstance.get(
        `/admin/payroll/monthly?month=${Number(
          month
        )}&year=${Number(year)}`
      );

      setWorkers(response.data?.workers || []);

      setSummary(
        response.data?.summary || {
          workers: 0,
          total: 0,
          paid: 0,
          pending: 0,
        }
      );
    } catch (error) {
      toast.error(
        error.response?.data?.detail ||
          "Impossible de charger les paiements du mois"
      );
    } finally {
      setLoading(false);
    }
  };

  const loadHistory = async () => {
    try {
      const response = await axiosInstance.get(
        "/admin/payments/history"
      );

      setHistory(response.data || []);
    } catch (error) {
      toast.error(
        "Impossible de charger l'historique des paiements"
      );
    }
  };

  useEffect(() => {
    loadMonthlyPayments();
  }, [month, year]);

  useEffect(() => {
    if (tab === "history") {
      loadHistory();
    }
  }, [tab]);

  const openPayment = async (worker) => {
    if (!worker.iban) {
      toast.error(
        "Aucun IBAN enregistré pour ce soignant. Ajoute son IBAN dans son profil."
      );
      return;
    }

    const communication =
      worker.payment_reference ||
      `SANA-CARE ${worker.first_name} ${worker.last_name} ${month}/${year}`;

    const payload = buildEpcPayload({
      bic: worker.bic,

      beneficiary:
        worker.account_holder ||
        `${worker.first_name || ""} ${
          worker.last_name || ""
        }`.trim(),

      iban: worker.iban,

      amount: worker.net,

      communication,
    });

    try {
      const qrDataUrl = await QRCode.toDataURL(
        payload,
        {
          width: 320,
          margin: 2,
        }
      );

      setPaymentModal({
        open: true,
        worker,
        qrDataUrl,
      });
    } catch {
      toast.error(
        "Erreur lors de la génération du QR code"
      );
    }
  };

  const confirmPayment = async () => {
    const worker = paymentModal.worker;

    if (!worker) return;

    const ok = window.confirm(
      `Confirmer le paiement de ${Number(
        worker.net || 0
      ).toFixed(2)} € à ${
        worker.first_name
      } ${worker.last_name} pour ${month}/${year} ?`
    );

    if (!ok) return;

    try {
      await axiosInstance.post(
        "/admin/payments/confirm",
        {
          user_id: worker.user_id,
          month: Number(month),
          year: Number(year),
        }
      );

      toast.success(
        "Paiement enregistré dans l'historique"
      );

      setPaymentModal({
        open: false,
        worker: null,
        qrDataUrl: "",
      });

      await loadMonthlyPayments();
    } catch (error) {
      toast.error(
        error.response?.data?.detail ||
          "Erreur lors de la confirmation"
      );
    }
  };

  const statusBadge = (status) => {
    if (status === "paid") {
      return (
        <Badge className="bg-emerald-100 text-emerald-700 border border-emerald-200">
          Payé
        </Badge>
      );
    }

    return (
      <Badge
        className="border"
        style={{
          backgroundColor: SANA_BLUE,
          color: SANA_BLUE_TEXT,
          borderColor: SANA_BLUE_HOVER,
        }}
      >
        À payer
      </Badge>
    );
  };

  return (
    <Layout title="Paiements">
      <div className="space-y-6">

        {/* TITRE + FILTRES */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
          <div>
            <h1
              className="text-3xl font-bold"
              style={{ color: SANA_BLUE_TEXT }}
            >
              Paiements des soignants
            </h1>

            <p className="text-gray-500 mt-1">
              Sélectionne un mois pour voir uniquement les
              personnes ayant travaillé pendant cette période.
            </p>
          </div>

          <div className="flex gap-3 flex-wrap">

            {/* MOIS */}
            <div>
              <label className="text-sm text-gray-600">
                Mois
              </label>

              <Select
                value={month}
                onValueChange={setMonth}
              >
                <SelectTrigger
                  className="w-[170px] bg-white"
                  style={{
                    borderColor: SANA_BLUE_HOVER,
                  }}
                >
                  <SelectValue />
                </SelectTrigger>

                <SelectContent>
                  {MONTHS.map((m) => (
                    <SelectItem
                      key={m.value}
                      value={m.value}
                    >
                      {m.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            {/* ANNÉE */}
            <div>
              <label className="text-sm text-gray-600">
                Année
              </label>

              <Select
                value={year}
                onValueChange={setYear}
              >
                <SelectTrigger
                  className="w-[120px] bg-white"
                  style={{
                    borderColor: SANA_BLUE_HOVER,
                  }}
                >
                  <SelectValue />
                </SelectTrigger>

                <SelectContent>
                  {years.map((y) => (
                    <SelectItem
                      key={y}
                      value={y}
                    >
                      {y}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            {/* ACTUALISER */}
            <Button
              variant="outline"
              onClick={loadMonthlyPayments}
              disabled={loading}
              className="self-end"
              style={{
                borderColor: SANA_BLUE_HOVER,
                color: SANA_BLUE_TEXT,
              }}
            >
              <RefreshCw
                size={16}
                className="mr-2"
              />

              Actualiser
            </Button>
          </div>
        </div>

        {/* ONGLETS */}
        <div className="flex gap-2">

          <Button
            onClick={() => setTab("current")}
            variant="outline"
            style={
              tab === "current"
                ? {
                    backgroundColor: SANA_BLUE,
                    borderColor: SANA_BLUE,
                    color: SANA_BLUE_TEXT,
                  }
                : {
                    borderColor: SANA_BLUE_HOVER,
                    color: SANA_BLUE_TEXT,
                  }
            }
          >
            <Euro
              size={16}
              className="mr-2"
            />

            Paiements du mois
          </Button>

          <Button
            onClick={() => setTab("history")}
            variant="outline"
            style={
              tab === "history"
                ? {
                    backgroundColor: SANA_BLUE,
                    borderColor: SANA_BLUE,
                    color: SANA_BLUE_TEXT,
                  }
                : {
                    borderColor: SANA_BLUE_HOVER,
                    color: SANA_BLUE_TEXT,
                  }
            }
          >
            <History
              size={16}
              className="mr-2"
            />

            Historique
          </Button>
        </div>

        {/* PAIEMENTS DU MOIS */}
        {tab === "current" && (
          <>
            <div className="grid grid-cols-2 xl:grid-cols-4 gap-4">

              <StatCard
                label="Soignants"
                value={summary.workers}
              />

              <StatCard
                label="Montant total"
                value={`${Number(
                  summary.total || 0
                ).toFixed(2)} €`}
                important
              />

              <StatCard
                label="Déjà payés"
                value={summary.paid}
              />

              <StatCard
                label="Restant à payer"
                value={summary.pending}
              />

            </div>

            <Card className="overflow-hidden">
              <CardContent className="p-0 overflow-x-auto">

                <table className="w-full min-w-[900px]">

                  <thead
                    style={{
                      backgroundColor: SANA_BLUE,
                    }}
                  >
                    <tr>
                      <th className="p-4 text-left">
                        Soignant
                      </th>

                      <th className="p-4 text-left">
                        Fonction
                      </th>

                      <th className="p-4 text-center">
                        Prestations
                      </th>

                      <th className="p-4 text-right">
                        Brut
                      </th>

                      <th className="p-4 text-right">
                        Retenue
                      </th>

                      <th className="p-4 text-right">
                        Net à payer
                      </th>

                      <th className="p-4 text-center">
                        Statut
                      </th>

                      <th className="p-4 text-right">
                        Action
                      </th>
                    </tr>
                  </thead>

                  <tbody>

                    {loading ? (
                      <tr>
                        <td
                          colSpan={8}
                          className="p-10 text-center text-gray-500"
                        >
                          Chargement...
                        </td>
                      </tr>
                    ) : workers.length === 0 ? (
                      <tr>
                        <td
                          colSpan={8}
                          className="p-10 text-center text-gray-500"
                        >
                          Aucun soignant n'a de prestation
                          terminée pour cette période.
                        </td>
                      </tr>
                    ) : (
                      workers.map((worker) => (
                        <tr
                          key={worker.user_id}
                          className="border-t hover:bg-[#F3F9F9] transition-colors"
                        >
                          <td className="p-4 font-semibold">
                            {worker.first_name}{" "}
                            {worker.last_name}
                          </td>

                          <td className="p-4">
                            {worker.role === "nurse"
                              ? "Infirmier"
                              : worker.role === "caregiver"
                              ? "Aide-soignant"
                              : worker.role}
                          </td>

                          <td className="p-4 text-center">
                            {worker.prestations_count}
                          </td>

                          <td className="p-4 text-right">
                            {Number(
                              worker.gross || 0
                            ).toFixed(2)}{" "}
                            €
                          </td>

                          <td className="p-4 text-right text-red-600">
                            -
                            {Number(
                              worker.discount || 0
                            ).toFixed(2)}{" "}
                            €
                          </td>

                          <td
                            className="p-4 text-right text-xl font-bold"
                            style={{
                              color: SANA_BLUE_TEXT,
                            }}
                          >
                            {Number(
                              worker.net || 0
                            ).toFixed(2)}{" "}
                            €
                          </td>

                          <td className="p-4 text-center">
                            {statusBadge(
                              worker.payment_status
                            )}
                          </td>

                          <td className="p-4 text-right">

                            {worker.payment_status ===
                            "paid" ? (
                              <Button
                                variant="outline"
                                disabled
                              >
                                <CheckCircle2
                                  size={16}
                                  className="mr-2"
                                />

                                Déjà payé
                              </Button>
                            ) : (
                              <Button
                                onClick={() =>
                                  openPayment(worker)
                                }
                                className="text-white"
                                style={{
                                  backgroundColor:
                                    SANA_BLUE_TEXT,
                                }}
                              >
                                <QrCode
                                  size={16}
                                  className="mr-2"
                                />

                                Payer
                              </Button>
                            )}

                          </td>
                        </tr>
                      ))
                    )}

                  </tbody>
                </table>

              </CardContent>
            </Card>
          </>
        )}

        {/* HISTORIQUE */}
        {tab === "history" && (
          <Card className="overflow-hidden">

            <CardContent className="p-0 overflow-x-auto">

              <table className="w-full min-w-[900px]">

                <thead
                  style={{
                    backgroundColor: SANA_BLUE,
                  }}
                >
                  <tr>
                    <th className="p-4 text-left">
                      Date
                    </th>

                    <th className="p-4 text-left">
                      Soignant
                    </th>

                    <th className="p-4 text-left">
                      Période
                    </th>

                    <th className="p-4 text-right">
                      Montant
                    </th>

                    <th className="p-4 text-left">
                      Référence
                    </th>

                    <th className="p-4 text-left">
                      Confirmé par
                    </th>
                  </tr>
                </thead>

                <tbody>

                  {history.length === 0 ? (
                    <tr>
                      <td
                        colSpan={6}
                        className="p-10 text-center text-gray-500"
                      >
                        Aucun paiement enregistré
                      </td>
                    </tr>
                  ) : (
                    history.map((p) => (
                      <tr
                        key={p.id}
                        className="border-t hover:bg-[#F3F9F9] transition-colors"
                      >
                        <td className="p-4">
                          {p.paid_at
                            ? new Date(
                                p.paid_at
                              ).toLocaleString(
                                "fr-BE"
                              )
                            : "—"}
                        </td>

                        <td className="p-4 font-semibold">
                          {p.first_name}{" "}
                          {p.last_name}
                        </td>

                        <td className="p-4">
                          {String(
                            p.month
                          ).padStart(
                            2,
                            "0"
                          )}
                          /{p.year}
                        </td>

                        <td
                          className="p-4 text-right font-bold"
                          style={{
                            color: SANA_BLUE_TEXT,
                          }}
                        >
                          {Number(
                            p.net_amount || 0
                          ).toFixed(2)}{" "}
                          €
                        </td>

                        <td className="p-4">
                          {p.payment_reference ||
                            "—"}
                        </td>

                        <td className="p-4">
                          {p.confirmed_by_name ||
                            "Admin"}
                        </td>
                      </tr>
                    ))
                  )}

                </tbody>
              </table>

            </CardContent>
          </Card>
        )}
      </div>

      {/* MODALE DE PAIEMENT */}
      {paymentModal.open &&
        paymentModal.worker && (
          <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4">

            <div className="w-full max-w-xl bg-white rounded-2xl shadow-2xl overflow-hidden">

              {/* HEADER */}
              <div
                className="p-5 flex justify-between items-center"
                style={{
                  backgroundColor: SANA_BLUE,
                  color: SANA_BLUE_TEXT,
                }}
              >
                <div>
                  <h2 className="text-2xl font-bold">
                    Paiement
                  </h2>

                  <p>
                    {
                      paymentModal.worker
                        .first_name
                    }{" "}
                    {
                      paymentModal.worker
                        .last_name
                    }
                  </p>
                </div>

                <Button
                  size="sm"
                  variant="ghost"
                  style={{
                    color: SANA_BLUE_TEXT,
                  }}
                  onClick={() =>
                    setPaymentModal({
                      open: false,
                      worker: null,
                      qrDataUrl: "",
                    })
                  }
                >
                  <X />
                </Button>
              </div>

              {/* CONTENU */}
              <div className="p-6 text-center">

                <p className="text-gray-500">
                  Montant à payer
                </p>

                <p
                  className="text-4xl font-bold mt-1"
                  style={{
                    color: SANA_BLUE_TEXT,
                  }}
                >
                  {Number(
                    paymentModal.worker.net ||
                      0
                  ).toFixed(2)}{" "}
                  €
                </p>

                <div
                  className="mt-5 text-sm text-left rounded-xl p-4 border"
                  style={{
                    backgroundColor:
                      "#F3F9F9",
                    borderColor:
                      SANA_BLUE,
                  }}
                >
                  <p>
                    <b>IBAN :</b>{" "}
                    {
                      paymentModal.worker
                        .iban
                    }
                  </p>

                  <p>
                    <b>Titulaire :</b>{" "}
                    {paymentModal.worker
                      .account_holder ||
                      `${paymentModal.worker.first_name} ${paymentModal.worker.last_name}`}
                  </p>

                  <p>
                    <b>Période :</b>{" "}
                    {month}/{year}
                  </p>

                  <p>
                    <b>Référence :</b>{" "}
                    {paymentModal.worker
                      .payment_reference ||
                      `SANA-CARE ${paymentModal.worker.first_name} ${paymentModal.worker.last_name} ${month}/${year}`}
                  </p>
                </div>

                {/* QR CODE */}
                <div className="flex justify-center mt-6">

                  <div
                    className="p-4 rounded-2xl border"
                    style={{
                      borderColor:
                        SANA_BLUE,
                      backgroundColor:
                        "#FFFFFF",
                    }}
                  >
                    <img
                      src={
                        paymentModal.qrDataUrl
                      }
                      alt="QR code de paiement"
                      className="w-[280px] h-[280px]"
                    />
                  </div>

                </div>

                <p className="text-xs text-gray-500 mt-3">
                  Scanne ce QR code avec une
                  application bancaire compatible
                  SEPA.
                </p>

                <Button
                  onClick={confirmPayment}
                  className="mt-6 w-full text-white h-12"
                  style={{
                    backgroundColor:
                      SANA_BLUE_TEXT,
                  }}
                >
                  <CheckCircle2
                    size={18}
                    className="mr-2"
                  />

                  Confirmer que le paiement est
                  effectué
                </Button>

              </div>
            </div>
          </div>
        )}
    </Layout>
  );
}

function StatCard({
  label,
  value,
  important = false,
}) {
  return (
    <Card
      className="border"
      style={{
        borderColor: SANA_BLUE,
      }}
    >
      <CardContent className="p-5">

        <p className="text-sm text-gray-500">
          {label}
        </p>

        <p
          className="text-2xl font-bold mt-1"
          style={
            important
              ? {
                  color: SANA_BLUE_TEXT,
                }
              : undefined
          }
        >
          {value}
        </p>

      </CardContent>
    </Card>
  );
}